import { render, staticRenderFns } from "./AdminReports.vue?vue&type=template&id=3affd42d&scoped=true&"
import script from "./AdminReports.vue?vue&type=script&lang=js&"
export * from "./AdminReports.vue?vue&type=script&lang=js&"
import style0 from "./AdminReports.vue?vue&type=style&index=0&id=3affd42d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3affd42d",
  null
  
)

export default component.exports